import script from "./PublicCountryNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicCountryNotice.vue?vue&type=script&setup=true&lang=js"

import "./PublicCountryNotice.vue?vue&type=style&index=0&id=e3f4ba70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f4ba70"]])

export default __exports__